export type ArtworksFilterState = {
  ids: number[];
};

export const DEFAULT_ARTWORK_IDS_FILTER_VALUE = [];
